import { Container, Grid, TablePagination, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import useSWR from 'swr';
import { Header } from '../../styles/shared/styles';
import { variantFetcher } from '../../service/SWRFetcher';
import DuplicateLeadsReportFilter from '../../components/DuplicateLeadsReport/filter';
import DuplicatedLeadsTable from '../../components/DuplicateLeadsReport/table';

const useStyles = makeStyles({});

const DuplicadeLeadsReport = () => {
  const classes = useStyles();

  const [filters, setFilters] = useState({
    partner_id: '',
    client_name: '',
    proposal_id: '',
    period_start: '',
    period_end: '',
    page: 1,
    per_page: 10,
  });

  const { data, mutate, isValidating } = useSWR(
    `/lead-duplicates?partner_id=${filters.partner_id}&client_name=${filters.client_name}&proposal_id=${filters.proposal_id}&date_start=${filters.period_start}&date_end=${filters.period_end}&page=${filters.page}&per_page=${filters.per_page}`,
    variantFetcher,
    { revalidateOnFocus: false }
  );

  const handleChangePage = (event, newPage) => {
    setFilters({ ...filters, page: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setFilters({ ...filters, page: 0, per_page: event.target.value });
    mutate();
  };

  const handleClearFilters = () => {
    setFilters({
      partner_id: '',
      period_start: '',
      period_end: '',
      client_name: '',
      proposal_id: '',
      page: 1,
      per_page: 10,
    });
  };

  return (
    <>
      <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -100 }}>
        <Container style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '1em' }}>
          <Header>
            <h1>Relatório de Leads Duplicados</h1>
          </Header>

          <DuplicateLeadsReportFilter
            filters={filters}
            setFilters={setFilters}
            handleClearFilters={handleClearFilters}
          />

          <TablePagination
            component="div"
            count={data?.meta?.total || 0}
            page={filters.page}
            onPageChange={handleChangePage}
            rowsPerPage={filters.per_page}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          <DuplicatedLeadsTable leads={data?.data || []} mutate={mutate}/>
        </Container>
      </motion.div>
    </>
  );
};

export default DuplicadeLeadsReport;
